import { ComedianInsert, getComedianByID } from "./comedian";
import { SpecialRow, getSpecialByID } from "./specials";

import { checkImages } from "./utils";
import createNoAuthSupabaseClient from "../supabase/supabase";

// Generated with https://saasbase.dev/tools/regex-generator
export const VALIDATE_SLUG_REGEX = "^(?!-)[a-z0-9]+(?:-[a-z0-9]+)*(?<!-)$";
export const VALIDATE_URL_REGEX =
  "^(https?://)?(www.)?[da-z-]+.[a-z]{2,6}(/.*)?$";

export const getSlugAlreadyInUse = async (slug: string) => {
  const supabase = createNoAuthSupabaseClient();
  const { count, status, error } = await supabase
    .from("comedians")
    .select("slug", { count: "exact", head: true })
    .eq("slug", slug);

  if (error) {
    console.error(error);
  } else if (status === 200) {
    if (count && count > 0) {
      return true;
    } else {
      return false;
    }
  }
  throw new Error(`Error while looking up the slug: ${slug} in the database.`);
};

export const validateComedianSlug = async (slug: string) => {
  const regex = new RegExp(VALIDATE_SLUG_REGEX);
  if (!regex.test(slug)) {
    const message =
      "The slug for this comedian is invalid. Please try a different one.";
    console.error(message);
    return { error: { message } };
  }

  // Verify slug is not already used
  const slugAlreadyInUse = await getSlugAlreadyInUse(slug);
  if (slugAlreadyInUse) {
    const message =
      "The slug you picked is already in use, please try a different one.";
    console.error(message);
    return { error: { message } };
  }
};

export const validateComedian = async (comedian: ComedianInsert) => {
  const {
    id,
    about,
    display_name,
    slug,
    about_img,
    signature_img,
    featured_special_id,
    published_at,
  } = comedian;

  if (!slug) {
    throw new Error(
      "You did not provide a slug for this comedian, please try again."
    );
  }

  // Look up Comedian with the given id to determine
  // if it exists already or if it's a new one
  const existingComedian = await getComedianByID(id!);

  // Comedian did not exist (i.e it's a new one), continue with validation
  if (!existingComedian) {
    const errors = await validateComedianSlug(slug);
    if (errors) {
      return errors;
    }
  } else {
    // Skip validation for the slug if it hasn't changed
    if (existingComedian.slug !== slug) {
      const errors = await validateComedianSlug(slug);
      if (errors) {
        return errors;
      }
    }
  }

  // If a featured special ID is passed, validate that it actually exists
  if (featured_special_id) {
    try {
      const featuredSpecial: SpecialRow | null = featured_special_id
        ? await getSpecialByID(featured_special_id!)
        : null;
      if (!featuredSpecial) {
        // This code is dead code for now, but I feel like we should leave it in case the getSpecialByID()
        // function changes an stops throwing when a special is not found, and instead returns null
        throw new Error(
          "An existing Special was not found for the UUID provided. Cannot continue with the comedian update"
        );
      }
    } catch (error) {
      console.error(error);
      return { error };
    }
  }

  // validate that cloudflare resources are valid
  const images = [about_img, signature_img];
  const imgError = await checkImages(images);
  if (imgError) {
    return imgError;
  }
};
